import React, { useState } from 'react';

import Box from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import ConfirmModal from 'src/components/shared/confirmModal/confirmModal';
import { JmrFlowTypes } from 'src/utils/jmrUtils';
import { type LimitationReviewItem } from 'src/utils/restrictionUtils';

import { SectionTitle, SectionWrapper } from '../common';

// **** Types **** //

interface RestrictionsReviewProps {
  restrictionReviewItems: LimitationReviewItem[];
  jmrFlowType: JmrFlowTypes;
  onConfirm: () => void;
}

// **** Components **** //

/**
 * Default component.
 */
const RestrictionsReview = ({ restrictionReviewItems, jmrFlowType, onConfirm }: RestrictionsReviewProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Box>
      {/* Header */}
      <SectionTitle
        label="Physical Restrictions"
        editButtonDisabled={jmrFlowType === JmrFlowTypes.AlternativePlacementRecommended}
        editButtonOnClick={() => setIsModalOpen(true)}
      />

      {/* Task List */}
      {restrictionReviewItems.length > 0 ? (
        restrictionReviewItems.map((restriction, i) => (
          <Box key={i} spacingInset="none none 300 none">
            <SectionWrapper label={restriction.label} items={restriction.items} />
          </Box>
        ))
      ) : (
        <Text type="b300" color="secondary">
          No tasks selected
        </Text>
      )}

      {/* Modals */}
      <ConfirmModal
        width="419px"
        modalTitle="Leave page"
        modalDescription="Leaving this page will restart your Job Match Results process."
        open={isModalOpen}
        setOpen={() => setIsModalOpen(false)}
        onConfirm={onConfirm}
      />
    </Box>
  );
};

// **** Export **** //

export default RestrictionsReview;
